import { Draggable, Droppable } from '@hello-pangea/dnd';
import { transportationKeys } from '../../../../../../../../consts/conditions';

import ConditionBody from '../../ConditionBody';
import classNames from 'classnames';
import ConditionBtnWithLine from '../../ConditionBtnWithLine';
import AddFilterBtn from '../../AddFilterBtn';
import FilterColumnCard from '../../FilterColumnCard';

import { ReplaceIcon } from '../icons';

import React from 'react';

export const SumIf = ({
  isChildrenGroup,
  cuurentItem,
  filterTypes,
  onChangeOperator,
  onSelectItem,
  onSelectCondition,
  parentFilterTypeId,
  onDeleteSelectedItems,
  addCondition,
  selectedItems,
  onChangeFunction,
  onChangeInputType,
  onChangeInput,
  onChangeColumn,
  columns,
  onAddListItem,
  onRemoveListItem
}) => {
  return (
    <>
      <div id="grid-table-sumif-root" className="condition-box">
        {isChildrenGroup && !cuurentItem && (
          <div
            id="grid-table-sumif-checkbox-line"
            className={classNames('checkbox_line', {
              ['group-checkbox']: cuurentItem?.conditions?.length > 0
            })}
          >
            <div className="line" />
            <input
              type="checkbox"
              className="checkbox"
              checked={selectedItems?.includes(cuurentItem?.id)}
              onClick={() => onSelectItem(cuurentItem?.id)}
            />
          </div>
        )}

        <div id="grid-table-sumif-list" className="filter-types">
          <Droppable droppableId={cuurentItem?.id} key={cuurentItem?.id}>
            {provided =>
              filterTypes
                .filter(item => item.conditions.length)
                .map((item, idx) => {
                  const filterTypeId = parentFilterTypeId || item.id;

                  return (
                    <div
                      key={item.id}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{ width: '100%' }}
                    >
                      <div
                        className={classNames('filter_card', {
                          ['isChildren']: isChildrenGroup,
                          ['noBorderTop']: !isChildrenGroup && idx > 0,
                          ['noBorderBottom']: true,
                          ['isFilter']: true
                        })}
                      >
                        <div id={`grid-table-sumif-item-${idx}`} className="filter_content">
                          <ConditionBtnWithLine
                            id={`grid-table-sumif-condition-${item.id}`}
                            onlyAnd
                            withActions={!isChildrenGroup && idx === 0 && filterTypes?.length > 0}
                            disableGroup={!selectedItems?.length > 0}
                            disableDelete={!selectedItems?.length > 0}
                            onClickDelete={() => onDeleteSelectedItems(filterTypeId)}
                            onClickGroup={() => addCondition(item.id, 'group', filterTypeId)}
                            label={item.conditionLabel}
                            onSelectCondition={val => onSelectCondition(filterTypeId, val, item.id)}
                          />

                          {item?.conditions?.map((value, idx) => {
                            if (value?.conditions?.length > 0)
                              return (
                                <Draggable key={value.id} draggableId={value.id} index={idx}>
                                  {(dragProvided, dragSnapshot) => {
                                    return (
                                      <div
                                        key={value.id}
                                        className="group-wrapper"
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        style={{
                                          ...dragProvided.draggableProps.style,
                                          width: '100%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                          opacity: dragSnapshot.isDragging ? 0.5 : 1
                                        }}
                                      >
                                        <div
                                          id={`grid-table-sumif-group-checkbox-${value.id}`}
                                          className="checkbox_line"
                                        >
                                          <input
                                            id={`grid-table-sumif-group-checkbox-input-${value.id}`}
                                            type="checkbox"
                                            className="checkbox"
                                            checked={selectedItems.includes(value.id)}
                                            onClick={() => onSelectItem(value.id)}
                                          />
                                        </div>

                                        <ConditionBody
                                          cuurentItem={value}
                                          filterTypes={[value]}
                                          selectedItems={selectedItems}
                                          onSelectItem={onSelectItem}
                                          addCondition={addCondition}
                                          isChildrenGroup={true}
                                          columns={columns}
                                          parentFilterTypeId={
                                            !isChildrenGroup ? filterTypeId : parentFilterTypeId
                                          }
                                          onChangeInput={onChangeInput}
                                          onChangeColumn={onChangeColumn}
                                          onChangeFunction={onChangeFunction}
                                          onChangeOperator={onChangeOperator}
                                          onChangeInputType={onChangeInputType}
                                          onSelectCondition={onSelectCondition}
                                          onAddListItem={onAddListItem}
                                          onRemoveListItem={onRemoveListItem}
                                        />

                                        <div
                                          id={`grid-table-sumif-group-replace-${value.id}`}
                                          className="replace-btn"
                                          {...dragProvided.dragHandleProps}
                                        >
                                          <ReplaceIcon />
                                        </div>
                                      </div>
                                    );
                                  }}
                                </Draggable>
                              );

                            return (
                              <Draggable key={value.id} draggableId={value.id} index={idx}>
                                {(dragProvided, dragSnapshot) => (
                                  <div
                                    id={`grid-table-sumif-row-${value.id}`}
                                    key={value.id}
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      opacity: dragSnapshot.isDragging ? 0.5 : 1
                                    }}
                                  >
                                    <FilterColumnCard
                                      id={`grid-table-sumif-card-${value.id}`}
                                      key={value.id}
                                      operator={value.operator}
                                      column={value.column}
                                      func={value.function}
                                      value={value.value}
                                      inputType={value.inputType}
                                      columns={columns}
                                      errors={value.errors}
                                      dragHandleProps={{
                                        ...dragProvided.dragHandleProps
                                      }}
                                      hiddenVariants={['column']}
                                      hideFunction={
                                        item.label === transportationKeys.FILTER ||
                                        item.label === transportationKeys.SUM_IF
                                      }
                                      isSelected={selectedItems.includes(value.id)}
                                      onSelect={() => onSelectItem(value.id)}
                                      onChangeFunction={val =>
                                        onChangeFunction(filterTypeId, value.id, val)
                                      }
                                      onChangeInputType={val =>
                                        onChangeInputType(filterTypeId, value.id, val)
                                      }
                                      onChangeColumn={val =>
                                        onChangeColumn(filterTypeId, value.id, val)
                                      }
                                      onChangeOperator={val =>
                                        onChangeOperator(filterTypeId, value.id, val)
                                      }
                                      onAddListItem={val =>
                                        onAddListItem(filterTypeId, value.id, val)
                                      }
                                      onRemoveListItem={id =>
                                        onRemoveListItem(filterTypeId, value.id, id)
                                      }
                                      onChangeInput={val =>
                                        onChangeInput(filterTypeId, value.id, val)
                                      }
                                    />
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}

                          {provided.placeholder}

                          <AddFilterBtn
                            id={`grid-table-sumif-add-${item.id}`}
                            hideGroupBtn={true}
                            onClick={type =>
                              addCondition(item.id, type, parentFilterTypeId || filterTypeId)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  );
                })
            }
          </Droppable>
        </div>
      </div>
    </>
  );
};
